/* Custom footer — folds menu columns on mobile, keeps them open on desktop */
(function () {
  'use strict';
  if (window.customElements && customElements.get('cf-footer')) return;

  var MOBILE = '(max-width: 749px)';

  class CfFooter extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia(MOBILE);
      this.items = Array.prototype.slice.call(this.querySelectorAll('details[data-cf-acc]'));

      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.onChange = this.onChange.bind(this);

      this.items.forEach(function (d) {
        var summary = d.querySelector(':scope > summary');
        if (summary) summary.addEventListener('click', this.onSummaryClick);
      }, this);

      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onChange);
      else if (this.mq.addListener) this.mq.addListener(this.onChange);

      this.apply();
    }

    disconnectedCallback() {
      if (!this.mq) return;
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onChange);
      else if (this.mq.removeListener) this.mq.removeListener(this.onChange);
    }

    onSummaryClick(e) {
      var d = e.currentTarget.parentElement;
      // Only folding columns on mobile can be opened/closed
      if (!this.mq.matches || d.getAttribute('data-fold') !== 'true') {
        e.preventDefault();
      }
    }

    onChange() {
      this.apply();
    }

    apply() {
      var mobile = this.mq.matches;
      this.items.forEach(function (d) {
        if (!mobile || d.getAttribute('data-fold') !== 'true') {
          d.open = true;
        } else {
          d.open = d.getAttribute('data-mobile-open') === 'true';
        }
      });
    }
  }

  customElements.define('cf-footer', CfFooter);
})();
